<div class="program-wrapper">
  @if (promptData()) {
    <div class="program-header">
      <h4 class="header">{{ promptData().header }}</h4>
      <p>{{ promptData().instructions }}</p>
    </div>

    <div class="program-content">
      @for (component of promptData().components | orderBy: 'order'; track $index) {
        <lib-prompt-renderer [isCreate]="true"
                             [isIneligible]="isIneligible()"
                             [formGroup]="formGroups[component.id!]"
                             [promptComponentInput]="component"
                             [reviewData]="reviewComponentData()"
                             [sessionId]="sessionId()"
                             (agreementSelectEmitter)="agreementSelectOutput($event)"
                             (buttonSelectEmitter)="buttonSelectOutput($event)"
                             (checkboxSelectEmitter)="checkboxSelectOutput($event)"
                             (decisionEmitter)="decisionComponentOutput($event)"
                             (dnpeLookupEmitter)="dnpeComponentOutput($event)"
                             (editSectionEmitter)="editPrompt($event)"
                             (fileUploadValuesEmitter)="fileUploadOutput($event)"
                             (selectSubSelectCheckboxEmitter)="selectSubSelectCheckboxOutput($event)" />
      }
    </div>
  }

  <div class="button-row">
    <button class="secondary_materials_button back-button xlarge_button" data-qa="back-button" disableRipple="true"
            mat-stroked-button [disabled]="isBackDisabled()" (click)="back()">
      <i class="fa-solid fa-chevron-left"></i>Back
    </button>
    @if (isReviewPrompt()) {
      @if (!isIneligible()) {
        <button class="primary_materials_button submit-button xlarge_button" data-qa="submit-button" disableRipple="true"
                mat-stroked-button (click)="submitEnrollment()">
          Submit
        </button>
      }
    } @else {
      <button class="primary_materials_button next-button xlarge_button" data-qa="next-button" disableRipple="true"
              mat-stroked-button [disabled]="!isPromptValid()" (click)="next()">
        Next<i class="fa-solid fa-chevron-right"></i>
      </button>
    }
  </div>
</div>
